import { render } from "./actionmodal.vue?vue&type=template&id=13b8973c&scoped=true"
import script from "./actionmodal.vue?vue&type=script&lang=js"
export * from "./actionmodal.vue?vue&type=script&lang=js"

import "./actionmodal.vue?vue&type=style&index=0&id=13b8973c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b8973c"]])

export default __exports__